module.exports = __webpack_public_path__ + "static/media/sg3tj0.a9ca76f6.png";